import * as React from "react";

const IconLocation = (props) => (
  <svg width={props.width || 16} height={props.height || 16} viewBox={`0 0 ${props.width || 16} ${props.height || 16}`} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.8873 0.204346L0.677246 6.54191L7.01478 9.07691L9.54979 15.4144L15.8873 0.204346ZM9.57644 11.6668L8.10451 7.98701L4.4247 6.51501L13.2563 2.83523L9.57644 11.6668Z"
      fill={props.color || "#fff"}
    />
  </svg>
)

export default IconLocation;